import type { LocalDataColumn } from "@nymbl/nos2-rules";
import type { ReactNode } from "react";

type Cell<R> = { render?: (row: R) => ReactNode; className?: string };

/**
 * A table's columns with their cells added. The columns themselves stay in plain modules, away
 * from JSX, so their values and help can be tested on their own.
 */
export function withCells<R>(
  columns: LocalDataColumn<R>[],
  cells: Record<string, Cell<R>>,
): LocalDataColumn<R>[] {
  return columns.map((column) => ({ ...column, ...cells[column.key] }));
}
